import dayjs from 'dayjs';

export default function getInitialEditValues(user = {}, medical) {
  const med = medical ?? {}; // ✅ if null or undefined, fallback to {}
  return {
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    email: user.email || "",
    phone: user.phone || "",
    gender: user.gender || "",
    birthdate: user.birthdate ? dayjs(user.birthdate) : null,
    groupeSanguin: med.groupeSanguin || "",
    adresse: med.adresse || "",
    avatar: undefined,
  };
}
